export default "__VITE_ASSET__D1FOpSxy__"